
function getSelectedVariantId(root) {
  // Dawn normally updates the URL when a variant is selected.
  const urlVariant = new URLSearchParams(window.location.search).get('variant');

  if (urlVariant) return urlVariant;

  // Fall back to the current product form selection.
  const productForm = document.querySelector(
    'product-form form[action*="/cart/add"] input[name="id"]'
  );

  if (productForm?.value) return productForm.value;

  // Final fallback to the variant initially rendered by Liquid.
  return root.querySelector('[data-store-stock-variant]')?.value;
}

async function loadStoreStock(root) {
  const results = root.querySelector('[data-store-stock-results]');
  const variantId = getSelectedVariantId(root);

  if (!variantId) {
    results.textContent = 'Please select a product variant.';
    return;
  }

  results.textContent = 'Checking store availability…';

  try {
    const response = await fetch(
      `/apps/store-stock?variant=${encodeURIComponent(variantId)}`,
      {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      }
    );

    if (!response.ok) {
      throw new Error(`Stock request failed: ${response.status}`);
    }

    const data = await response.json();

    if (!Array.isArray(data.locations)) {
      throw new Error('Invalid stock response');
    }

    // Ignore an old response if the customer changed variants
    // while the request was in progress.
    if (getSelectedVariantId(root) !== variantId) {
      return loadStoreStock(root);
    }

    results.replaceChildren();

    if (data.locations.length === 0) {
      results.textContent = 'No store availability information found.';
      return;
    }

    data.locations.forEach((location) => {
      const row = document.createElement('div');
      row.className = 'store-stock__location';

      const name = document.createElement('span');
      name.textContent = location.name;

      const quantity = document.createElement('span');
      quantity.className = 'store-stock__quantity';

      if (
        location.available === null ||
        location.available === undefined
      ) {
        quantity.textContent = 'Quantity unavailable';
      } else {
        quantity.textContent =
          `${Number(location.available)} available`;
      }

      row.append(name, quantity);
      results.append(row);
    });
  } catch (error) {
    console.error('Store stock lookup failed:', error);
    results.textContent =
      'Unable to check stock right now. Please try again.';
  }
}

// Open and close the stock panel.
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-store-stock-button]');
  if (!button) return;

  const root = button.closest('[data-store-stock]');
  if (!root) return;

  const panel = root.querySelector('[data-store-stock-panel]');
  if (!panel) return;

  const isOpen = button.getAttribute('aria-expanded') === 'true';

  if (isOpen) {
    button.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    return;
  }

  button.setAttribute('aria-expanded', 'true');
  panel.hidden = false;

  // Always fetch the currently selected variant.
  loadStoreStock(root);
});

// Refresh the quantities if the customer changes variants
// while the stock panel is already open.
document.addEventListener('change', (event) => {
  if (!event.target.closest('variant-selects, variant-radios')) return;

  document.querySelectorAll('[data-store-stock]').forEach((root) => {
    const button = root.querySelector('[data-store-stock-button]');
    const panel = root.querySelector('[data-store-stock-panel]');

    if (
      button?.getAttribute('aria-expanded') === 'true' &&
      panel &&
      !panel.hidden
    ) {
      loadStoreStock(root);
    }
  });
});
